
import { Vue, Component, Prop } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import convertSecondsToReadable from "@/utils/convertSecondsToReadable";
import { Project_Activity_Request_More_Hours } from "@/generated/graphql";

@Component({
    components: {
        ModalContent,
        ModalFullScreen
    }
})
export default class DeclinedReasonConversationModal extends Vue {
    @Prop({ type: Object, required: true }) readonly time!: Project_Activity_Request_More_Hours ;

    processing: boolean = false;
    declineDisabled: boolean = false;
    reason: string = "";
    convertSecondsToReadable = convertSecondsToReadable

    closeModal(): void {
        this.$emit("closeRequestedHoursDeclineModal");
    }
}
